import { render, staticRenderFns } from "./modalCriarLink.vue?vue&type=template&id=598bc4b8&scoped=true"
import script from "./modalCriarLink.vue?vue&type=script&lang=js"
export * from "./modalCriarLink.vue?vue&type=script&lang=js"
import style0 from "./modalCriarLink.vue?vue&type=style&index=0&id=598bc4b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598bc4b8",
  null
  
)

export default component.exports